import { Unit21DataClassifier } from 'app/modules/dataSettings/responses';
import {
  OperandTypes,
  SymbolTable,
} from 'app/modules/rulesAdvanced/lib/SymbolTable';
import { ValueTypes } from 'app/modules/rulesAdvanced/models';

export const TXN_EVENT_COMMON_DROPDOWN_SYMBOLS: SymbolTable = Object.freeze({
  // NOTE: builderType === 'dropdown'
  u21_ach_risk_score: {
    type: OperandTypes.NUMBER,
    text: 'Unit21 ACH risk score',
    value: {
      operandType: OperandTypes.NUMBER,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'u21_ach_risk_score',
        label: 'u21_ach_risk_score',
        model: 'txn_event',
        datatype: 'number',
      },
    },
  },
  external_fee: {
    type: OperandTypes.NUMBER,
    text: 'Transaction / External fee',
    value: {
      operandType: OperandTypes.NUMBER,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'external_fee',
        label: 'external_fee',
        model: 'txn_event',
        datatype: 'number',
        cardinality: 'many',
      },
    },
  },
  'geolocation.country': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Country',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.country',
        label: 'geolocation.country',
        model: 'txn_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.city': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / City',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.city',
        label: 'geolocation.city',
        model: 'txn_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.postal_code': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Postal code',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.postal_code',
        label: 'geolocation.postal_code',
        model: 'txn_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.longitude': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Longitude',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.longitude',
        label: 'geolocation.longitude',
        model: 'txn_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.latitude': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Latitude',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.latitude',
        label: 'geolocation.latitude',
        model: 'txn_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  ip_is_bot: {
    type: OperandTypes.TEXT,
    text: 'IP uses bot',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_bot',
        label: 'ip_uses_bot',
        model: 'txn_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
  ip_is_vpn: {
    type: OperandTypes.TEXT,
    text: 'IP uses VPN',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_vpn',
        label: 'ip_uses_vpn',
        model: 'txn_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
  ip_is_proxy: {
    type: OperandTypes.TEXT,
    text: 'IP uses proxy',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_proxy',
        label: 'ip_uses_proxy',
        model: 'txn_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
  ip_is_tor: {
    type: OperandTypes.TEXT,
    text: 'IP uses Tor',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_tor',
        label: 'ip_uses_tor',
        model: 'txn_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
});
